export const COMEET_NAME = 'karma';
export const COMEET_UID = 'E6.00B';
export const COMEET_TOKEN = '6EB2982DD637580306D029826EB3E43';
export const CAREERS_EMAIL = 'jobs@karmanow.com';
